import './table.scss';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import moment from 'moment';
import Chip from '@material-ui/core/Chip';

// import Chip from '@material-ui/core/Chip';
import Seacrch from './search';
import Actions from './actions';

import { actions as projectListActions } from 'redux/arqFinishes/projectList/reducer';
import { getProjectListTableData } from 'redux/arqFinishes/projectList/selector';
import Button from '@material-ui/core/Button';
import DataTable from 'components/dataTable';
import { getStatusFile } from 'redux/reports/selector';
import { requests as reportsRequests } from 'redux/reports/reducer';
import { getCountryProfile } from 'redux/profile/selector';

const formatDate = 'DD/MM/YYYY';
const columns = [
  {
    prop: 'subtype',
    label: 'Tipo de proyecto',
    format: (value) => {
      switch (value) {
        case 'Dinoc':
          return <FormattedMessage id="3M™ DI-NOC™" />;
        case 'DinocSmall':
          return <FormattedMessage id="3M™ DI-NOC™ Small Project" />;
        case 'Fasara':
          return <FormattedMessage id="Glass Finishes" />;
        case 'FasaraSmall':
          return <FormattedMessage id="Glass Finishes Small Project" />;
      }
    },
  },
  { prop: 'data.name', label: 'Proyecto' },
  {
    prop: 'subtype',
    label: 'Cliente',
    format: (value, row) => {
      if (value === 'DinocSmall' || value === 'FasaraSmall') {
        if (row.data.status === 'Cliente') {
          return row.customer.firstname;
        } else {
          return row.customer.companyname;
        }
      }

      return row.data.companyname;
    },
  },
  {
    prop: 'data.status',
    label: 'Estado',
    format: (value, row) => {
      let textColor = '';
      let color = '';
      switch (value.toUpperCase()) {
        case 'PERDIDA':
          color = '#F00';
          textColor = '#FFF';
          break;
        case 'PENDIENTE':
          color = '#999';
          textColor = '#FFF';
          break;
        case 'GANADA':
          if (row.code) {
            color = '#73c968';
            textColor = '#FFF';
          } else {
            color = '#ffaa00';
            textColor = '#FFF';
          }
          break;
        case 'CANCELADA':
          color = '#601490';
          textColor = '#FFF';
          break;
        case 'CLIENTE':
          color = '#c919d6';
          textColor = '#FFF';
          break;
        default:
          color = '#999';
          textColor = '#FFF';
          value = 'Pendiente';
          break;
      }

      return (
        <Chip
          style={{
            backgroundColor: color,
            color: textColor,
            fontWeight: 'bold',
          }}
          label={
            row.code ? (
              <FormattedMessage id="Ganada / Cerrada" />
            ) : (
              <FormattedMessage id={value} />
            )
          }
        />
      );
    },
  },
  {
    prop: 'data.applications',
    label: 'Producto',
    format: (value, row) => {
      var data = '';
      if (row.subtype === 'Fasara' || row.subtype === 'FasaraSmall') {
        value.forEach((element) => {
          if (!!element.filmData?.name) {
            data += element.filmData.name + '\n';
          } else {
            data += element.film + '\n';
          }
        });
      } else {
        value.forEach((element) => {
          if (!!element.filmData?.name) {
            data += element.filmData.name + '\n';
          } else {
            data += element.film + '\n';
          }
        });
      }
      return <div className="display-linebreak">{data}</div>;
    },
  },
  {
    prop: 'created',
    label: 'Creación',
    format: (value, row) => moment(value).format(formatDate),
  },
  {
    prop: 'code',
    label: 'Certificado de garantía',
  },
  // {
  //   prop: 'hasComplaint',
  //   label: 'Reclamo',
  //   format: (value) => (
  //     <Chip
  //       color={value ? 'primary' : 'secondary'}
  //       label={value ? 'Abierto' : 'NO'}
  //     />
  //   ),
  // },
  {
    prop: 'uuid',
    label: 'Acciones',
    format: (value, row) => <Actions {...{ value, row }} />,
  },
];

const Table = ({ setFilter, downloadFile, country, file, ...props }) => {
  useEffect(() => {
    setFilter();
  }, [setFilter]);

  if (
    country == 'AR' ||
    country == 'BO' ||
    country == 'CE' ||
    country == 'CL' ||
    country == 'CO' ||
    country == 'CR' ||
    country == 'DO' ||
    country == 'EC' ||
    country == 'GT' ||
    country == 'HN' ||
    country == 'JM' ||
    country == 'MX' ||
    country == 'PA' ||
    country == 'PE' ||
    country == 'PY' ||
    country == 'SV' ||
    country == 'UY'
  ) {
    fileName = 'garantia-Arqfinishes.csv';
  } else if (country == 'BR' || country == 'PT') {
    fileName = 'garante-Arqfinishes.csv';
  } else if (country == 'DE') {
    fileName = 'garantie-Arqfinishes.csv';
  } else if (country == 'NL') {
    fileName = 'garantie-Arqfinishes.csv';
  } else {
    fileName = 'warranty-Arqfinishes.csv';
  }
  return (
    <>
      <div className="row">
        <div className="col-xs-6 col-md-6 col-lg-3">
          <Seacrch />
        </div>
        <div className="col-xs-6 col-md-6 col-lg-1 offset-lg-8">
          <Button
            variant="outlined"
            onClick={downloadFile}
            disabled={file.isLoading}
          >
            <FormattedMessage id="Export..." />
          </Button>
        </div>
      </div>
      <div>
        <div className="kt-space-20" />
        <DataTable
          columns={columns}
          onChangePage={(e, v) =>
            setFilter({
              page: v + 1,
            })
          }
          onChangeRowsPerPage={(e) =>
            setFilter({
              page: 1,
              perPage: e.target.value,
            })
          }
          {...props}
        />
      </div>
    </>
  );
};
let fileName;

export const mapStateToProps = (state) => ({
  ...getProjectListTableData(state),
  file: getStatusFile(fileName)(state),
  country: getCountryProfile(state),
});
export const mapDispatchToProps = (dispatch) => ({
  setFilter: (filter) => dispatch(projectListActions.setFilter(filter)),
  downloadFile: () =>
    dispatch(
      reportsRequests.fetch({
        report: '/reports/garantias/arqFinishes',
        fileName,
      }),
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(Table);

// export const mapDispatchToProps = (dispatch) => ({
//   setFilter: (filter) => dispatch(projectListActions.setFilter(filter)),
// });

// export default connect(getProjectListTableData, mapDispatchToProps)(Table);
